import { toDateReadable } from '@gov-nx/utils/common';
import { PPPTypeOptions } from './constants';
import type { PPPZapisForm } from './formSteps/formSteps.types';
import type { PPPLocaleReturnType } from '../usePPPLocale';

export const formatDateRange = (
	from?: Date | string | null,
	to?: Date | string | null,
	unknownLabel: string = 'neurčeno'
) => {
	const fromStr = from ? toDateReadable(from) : unknownLabel;
	const toStr = to ? toDateReadable(to) : unknownLabel;
	return `${fromStr} - ${toStr}`;
};

export const resolvePPPSelectLabel = (
	input: string | PPPTypeOptions,
	options: { label: string; value: string }[],
	t: PPPLocaleReturnType['t']
): string => {
	switch (input) {
		case PPPTypeOptions.PodnetKDoplneniSeznamu:
			return t('zapis.form.step2.PPPSelect.podnet-k-doplneni-seznamu');
		default:
			return options.find((option) => option.value === input)?.label ?? input;
	}
};

export const onIsOVMDefunctChange = ({
	isOVMDefunctChecked,
	onOVMDefunctChecked,
}: {
	isOVMDefunctChecked: boolean;
	onOVMDefunctChecked: () => void;
}) => {
	if (!isOVMDefunctChecked) {
		return;
	}

	onOVMDefunctChecked();
};

export const onPPPSelectChange = (onPPPOvmAutocompleteReset: () => void) =>
	onPPPOvmAutocompleteReset();

export const resolveIsPPPOvmSearchVisible = (
	pppTypeCode: string | undefined | null
): boolean =>
	!!pppTypeCode && pppTypeCode !== PPPTypeOptions.PodnetKDoplneniSeznamu;

export const resolveRecapOvmName = (
	formData: Pick<
		PPPZapisForm,
		| 'PPPSelect'
		| 'isOVMDefunct'
		| 'defunctOVMName'
		| 'missingPPPOvm'
		| 'pppOvmAutocomplete'
	>
): string | undefined => {
	if (formData.isOVMDefunct) {
		return formData.defunctOVMName || undefined;
	}

	if (formData.PPPSelect === PPPTypeOptions.PodnetKDoplneniSeznamu) {
		return formData.missingPPPOvm?.selected?.nazev;
	}

	return formData.pppOvmAutocomplete?.selected?.nazev;
};
